import { Directive, signal, TemplateRef, ViewContainerRef, WritableSignal } from '@angular/core';

@Directive({
  selector: '[eurogardTableRowActionExecuting]',
  exportAs: 'eurogardTableRowActionExecuting',
  standalone: true,
})
export class TableRowActionExecutingDirective {
  public shown: WritableSignal<boolean> = signal(false);

  constructor(
    public readonly templateRef: TemplateRef<void>,
    private readonly vcr: ViewContainerRef,
  ) {
  }

  public show(): void {
    this.vcr.createEmbeddedView(this.templateRef);
    this.shown.set(true);
  }

  public hide(): void {
    this.vcr.clear();
    this.shown.set(false);
  }
}
